export default __webpack_public_path__ + "static/media/officeLayout.c87927d8.png";